import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listingsService } from '../../../api';

const PLACEHOLDER = '/images/placeholder.jpg';
const MAX_CARS = 5;

function formatPrice(price: any): string {
  const n = Number(price);
  if (!price || isNaN(n)) return 'Price on request';
  return `€ ${n.toLocaleString('de-DE')}`;
}

const PopularCarsList: React.FC = () => {
  const navigate = useNavigate();
  const [cars, setCars] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listingsService.getAll({ limit: MAX_CARS, page: 1 })
      .then(res => setCars(res?.listings?.slice(0, MAX_CARS) ?? []))
      .catch(() => setCars([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bmm-cars-list">
        {Array.from({ length: MAX_CARS }).map((_, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: 8 }}>
            <div className="bmm-skeleton" style={{ width: 62, height: 46, borderRadius: 6 }} />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <div className="bmm-skeleton" style={{ height: 12, width: '80%' }} />
              <div className="bmm-skeleton" style={{ height: 12, width: '50%' }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="bmm-cars-list">
      {cars.map(car => {
        const thumb = car.thumbnailUrl || car.image || PLACEHOLDER;
        const name = car.title || `${car.year ?? ''} ${car.make ?? ''} ${car.model ?? ''}`.trim();
        const href = `/listing/${car.slug || car.id}`;
        return (
          <a
            key={car.id}
            className="bmm-car-item"
            href="#"
            onClick={e => { e.preventDefault(); navigate(href); }}
          >
            <img
              className="bmm-car-thumb"
              src={thumb}
              alt={name}
              onError={e => { (e.currentTarget as HTMLImageElement).src = PLACEHOLDER; }}
            />
            <div className="bmm-car-info">
              <div className="bmm-car-name">{name}</div>
              <div className="bmm-car-price">{formatPrice(car.price)}</div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default PopularCarsList;
